import { useNavigate } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '../store/hooks/reduxHooks';
import { handleLogout } from '../utils/sessionManager';

export const UnauthorizedPage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { user, isAuthenticated } = useAppSelector(state => state.auth);
  
  // Determine where to send the user back based on their role
  const handleGoBack = () => {
    if (!user || !isAuthenticated) {
      navigate('/login');
      return;
    }
    
    // Redirect based on user role
    switch (user.role) {
      case 'admin':
        navigate('/admin/dashboard');
        break;
      case 'superadmin':
        navigate('/superadmin/dashboard');
        break;
      case 'cleverpeuser':
        navigate('/cleverpeuser/dashboard');
        break;
      default:
        navigate('/login');
    }
  };
  
  // Handle logout and redirect to login
  const handleLogoutClick = () => {
    handleLogout(dispatch);
  };
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full space-y-8 p-10 bg-white rounded-xl shadow-lg">
        <div className="text-center">
          <h1 className="text-4xl font-gilroy-bold text-red-600 mb-2">Access Denied</h1>
          <p className="text-xl font-gilroy-medium text-gray-700 mb-8">
            You don't have permission to access this page.
          </p>
          <p className="text-brand-gray mb-8">
            Please contact your administrator if you believe this is an error.
          </p>
          
          <div className="flex flex-col space-y-4">
            <button
              onClick={handleGoBack}
              className="w-full inline-flex justify-center py-3 px-4 border border-transparent shadow-sm text-sm font-gilroy-medium rounded-md text-white bg-brand-blue hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              {isAuthenticated ? 'Return to Dashboard' : 'Go to Login'}
            </button>
            
            {isAuthenticated && (
              <button
                onClick={handleLogoutClick}
                className="w-full inline-flex justify-center py-3 px-4 border border-gray-300 shadow-sm text-sm font-gilroy-medium rounded-md text-red-600 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
              >
                Logout and Login Again
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}; 